import { ThemeProvider } from '@emotion/react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import './global.css'
import { store } from './store'
import { theme } from './utils'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      // console.log('Service Worker registered with scope:', registration.scope)
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error)
    })
}

function Root() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        {/* <ToastContainer position={`${mobile ? 'top-right' : 'bottom-right'}`} /> */}
        <ToastContainer
          position={'bottom-right'}
          draggable="touch"
          draggableDirection="y"
        />
        <App />
      </ThemeProvider>
    </Provider>
  )
}

root.render(<Root />)
